






























import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class FilterPillsRow extends Vue {
  @Prop({ type: String, default: "" }) label!: string;
  @Prop({ type: Array, default: () => [] }) items!: any[];
  @Prop({ default: null }) activeId!: any;
  @Prop({ type: String, default: "id" }) itemIdKey!: string;
  @Prop({ type: String, default: "name" }) itemLabelKey!: string;
  @Prop({ type: Boolean, default: false }) clearable!: boolean;
  @Prop({ type: String, default: "" }) clearLabel!: string;
  @Prop({ type: Boolean, default: true }) scroll!: boolean;

  get isClearActive() {
    return this.activeId === null || this.activeId === undefined || this.activeId === "";
  }

  getItemId(item: any) {
    if (item === null || item === undefined) {
      return "";
    }
    const value = item[this.itemIdKey];
    if (value === undefined || value === null || value === "") {
      return item;
    }
    return value;
  }

  getItemKey(item: any) {
    return this.getItemId(item);
  }

  getItemLabel(item: any) {
    if (item === null || item === undefined) {
      return "";
    }
    const value = item[this.itemLabelKey];
    if (value === undefined || value === null) {
      return "";
    }
    return value.toString();
  }

  isActive(item: any) {
    if (this.activeId === null || this.activeId === undefined || this.activeId === "") {
      return false;
    }
    return this.getItemId(item) === this.activeId;
  }

  emitSelect(item: any) {
    this.$emit("select", item);
  }

  emitClear() {
    this.$emit("clear");
  }
}
